import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { ISupplierModel } from '../types';
import { endpointManager } from '../../../services/endpoint.service';

interface IProps {
    shouldAutoFetch?: boolean;
    onSuccess?: (data: ISupplierModel[] | undefined) => void;
}

export const useGetSupplierData = (
  {
    shouldAutoFetch,
    onSuccess,
  }: IProps,
) => {
  const { getVendorsListUrl } = endpointManager();
  return useQuery(
    'GetSupplierData',
    async () => {
      const res = await httpService.get(getVendorsListUrl());
      return res.data;
    },
    {
      enabled: shouldAutoFetch || false,
      refetchOnWindowFocus: false,
      staleTime: 30000,
      cacheTime: 60000,
      onError: (e:IServerErrorResponse) => {
        const { localizedMessage, message, code } = flattenServerErrorResponse(e);
        trackMixPanel('Error Occurred During Move Money Flow', {
          'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Address Book', Flow: 'Mail a Check',
        });
        toast.error(localizedMessage || message || 'Please try again.', {
          position: 'bottom-center',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      },
      onSuccess: (data: any) => {
        if (onSuccess) onSuccess(data?.suppliers);
      },
    },
  );
};
